import Bloc from './Bloc.js';
import Types from './Types.js';

export default class ChangeMana extends Bloc {

	constructor (src, ctx) {

		super("changemana", src, ctx, true);
		this.f = (src, ins) => {
			ins[0].changeMana(ins[1]);
			return [];
		};
		this.types = [Types.card, Types.int];
	}
}